import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import MessageSubjectSchema, { MessageSubjectJSON } from "notifications/message-notifications/message-info/message-subject-schema";

export default class MessageSubject {
  public static create(subject: string): MessageSubject {
    const parsed = MessageSubjectSchema.validateJSON(subject);
    return new MessageSubject(parsed);
  }

  public static fromJSON(
    json: MessageSubjectJSON | null | undefined
  ): MessageSubject | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = MessageSubjectSchema.validateJSON(json);
    return new MessageSubject(parsed);
  }
  
  public constructor(public readonly value: string) { }

  public toJSON(): MessageSubjectJSON | null | undefined {
    return MessageSubjectSchema.serialize(this);
  }

  public isEqualTo(other: MessageSubject | null | undefined): boolean {
    return this.value === other?.value;
  }
  
  public toString(): string {
    return `MessageSubject { value: ${this.value} }`;
  }
}
